import React, { useCallback, useState } from 'react';
import { View } from 'react-native';

const LinePointWrapper = ({ children, points = [] }) => {
  const [layout, setLayout] = useState(null);
  const [pointSizes, setPointSizes] = useState(null);

  const onLayout = (e) => {
    const { width, height } = e.nativeEvent.layout;

    setLayout({ width, height });
  };

  const computeLeft = useCallback(
    (percent, index) => {
      if (!layout) {
        return 0;
      }

      const clamped = Math.max(0, Math.min(100, percent));
      const baseLeft = (clamped / 100) * layout.width;

      const width = pointSizes?.[index]?.width ?? 0;
      const centeredLeft = baseLeft - width / 2;

      const minLeft = 0;
      const maxLeft = layout.width - width;

      return Math.max(minLeft, Math.min(centeredLeft, maxLeft));
    },
    [layout, pointSizes]
  );

  const handlePointLayout = (index, event) => {
    const { width, height } = event.nativeEvent.layout;
    setPointSizes((prev) => {
      const prevSize = prev?.[index];
      if (prevSize?.width === width && prevSize?.height === height) {
        return prev;
      }

      return {
        ...(prev ?? {}),
        [index]: { width, height },
      };
    });
  };

  return (
    <View onLayout={onLayout} style={{ position: 'relative', width: '100%' }}>
      {children}

      {layout
        ? points.map(({ positionPercent, pointComponent }, index) => {
            if (!positionPercent) {
              return null;
            }

            return (
              <View
                key={index}
                onLayout={(event) => handlePointLayout(index, event)}
                style={{
                  position: 'absolute',
                  left: computeLeft(positionPercent, index),
                  top: 0,
                  height: '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {pointComponent()}
              </View>
            );
          })
        : null}
    </View>
  );
};

export default LinePointWrapper;
